import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import AppNavbar from '../components/AppNavbar';
import BottomNav from '../components/BottomNav';
import { TabFacturas } from './Clientes';

const FacturasClienteNuevo: React.FC = () => {
  const navigate = useNavigate();
  const clientDataJSON = localStorage.getItem('clientData');
  const clientData = clientDataJSON ? JSON.parse(clientDataJSON) : null;

  if (!clientData) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <AppNavbar />
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p style={{ color: 'var(--sn-texto-2)' }}>No se encontraron datos del cliente.</p>
        </div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <AppNavbar />

      <div style={{ flex: 1, overflowY: 'auto' as const }}>
        <div style={{ background: 'var(--sn-superficie)', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid var(--sn-borde)', position: 'sticky', top: 0, zIndex: 10 }}>
          <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: 'var(--sn-marca)' }}>
            <FaArrowLeft size={18} />
          </button>
          <div style={{ fontWeight: 700, fontSize: 15 }}>🧾 Mis Facturas</div>
        </div>

        <TabFacturas clienteId={clientData.id} cedula={clientData.cedula} nombre={clientData.nombre} />
      </div>

      <BottomNav />
    </div>
  );
};

export default FacturasClienteNuevo;
